import { render, staticRenderFns } from "./AgentForm.vue?vue&type=template&id=f90c7840&scoped=true"
import script from "./AgentForm.vue?vue&type=script&lang=js"
export * from "./AgentForm.vue?vue&type=script&lang=js"
import style0 from "./AgentForm.vue?vue&type=style&index=0&id=f90c7840&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f90c7840",
  null
  
)

export default component.exports